module.exports = __webpack_public_path__ + "img/bono-innovacion.23dc1b79.webp";